import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import {
  ILLUSTRATION_DEFAULTS,
  ILLUSTRATION_KEY_MAP,
  TIllustrationProps,
} from "@/ui/components/primitives/Illustration";

export const Illustration: FC<TIllustrationProps> = (
  {
    illustration,
    className,
    "aria-hidden": ariaHidden = ILLUSTRATION_DEFAULTS["aria-hidden"],
    ...props
  },
) => {
  const IllustrationElement = ILLUSTRATION_KEY_MAP[illustration];

  return (
    <div
      {...props}
      data-component="Illustration"
      data-illustration={illustration}
      aria-hidden={ariaHidden}
      className={cn(
        "w-full",
        className,
      )}
    >
      <IllustrationElement />
    </div>
  );
};

Illustration.displayName = "Illustration";
